import {useMemo, FC, ReactNode} from "react"

import cn from "classnames"

import {Anchor} from "components/Anchor"

import LoginIcon from "public/icons/login.svg"
import ProfileIcon from "public/icons/profile.svg"

export interface UserHeaderProps {
  isAuthenticated?: boolean
  className?: string
  children?: ReactNode
}

export const UserHeader: FC<UserHeaderProps> = ({
  isAuthenticated = false,
  className,
  children
}) => {
  const [link, Icon] = useMemo(
    () => (isAuthenticated ? ["/profile", ProfileIcon] : ["/login", LoginIcon]),

    [isAuthenticated]
  )

  return (
    <div className={cn("flex p-5 justify-between", className)}>
      {children}

      <Anchor href={link}>
        <Icon />
      </Anchor>
    </div>
  )
}
